export default "__VITE_ASSET__Dc7TLOWg__"